module.exports = ".modal-dialog {\r\n    width: calc(100% - 20px);\r\n}\r\n\r\n.modal-dialog-input {\r\n    width: 100%;\r\n    border: 1px solid #CCC;\r\n    padding: 3px 6px 3px 6px;\r\n}\r\n\r\n.hideTableIMG {\r\n    display: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/menumange/menumange.component.css
// module id = ./src/app/admin/menumange/menumange.component.css
// module chunks = main